import { useLanguage } from '@/context/LanguageContext'
import { useTheme } from '@/context/ThemeContext'
import { useCmsApi } from '@/services/cms-api'
import { IMG_URL, resolveImageUrl } from '@/utils/constants'
import useIntl from '@/utils/intl'
import { styled, useAutocomplete } from '@mui/material'
import Image from 'next/image'
import React, { FunctionComponent, useEffect, useState } from 'react'
import PricePackage from './component/pricePackage'
import DataPacakge from './component/dataPackage'
import MessagePackage from './component/messagePackage'
import classNames from 'classnames'

const RoamingPage: FunctionComponent = () => {
  const { getRoaming } = useCmsApi()
  const { locale } = useLanguage()
  const { theme } = useTheme()
  const { translate } = useIntl()
  const [selectedService, setSelectedService] = useState<string | null>(null)
  const [selectedService2, setSelectedService2] = useState<string | null>('price_package')
  const [data, setData] = useState<any[]>([])

  useEffect(() => {
    void fetchRoaming()
  }, [])

  const fetchRoaming = async (): Promise<void> => {
    try {
      const res = await getRoaming()
      setData(res?.data ?? [])
    } catch (e) {
      console.error(e)
    }
  }

  const {
    getRootProps,
    getInputProps,
    getListboxProps,
    getOptionProps,
    groupedOptions,
    focused
  } = useAutocomplete({
    id: 'use-autocomplete-demo',
    options: data ?? [],
    getOptionLabel: (option) => {
      const name = locale === 'en' ? option?.nameEn ?? 'No Name' : option?.nameMn ?? 'No Name'
      return `${option?.prefixCode ?? ''} ${name}`.trim()
    },
    onChange: (event, newValue) => setSelectedService(newValue?.id ?? null)
  })

  const dummyData2 = [
    { id: 'price_package', nameMn: 'Дуудлагын тариф', nameEn: 'Call rate' },
    { id: 'data_packages', nameMn: 'Дата багцууд', nameEn: 'Data Package' },
    { id: 'message_package', nameMn: 'Мессэж багцууд', nameEn: 'SMS Package' }
  ]

  return (
    <div className='w-full flex justify-center'>
      <div className='bg-surfaceInverse w-[95vw] rounded-2xl lg:p-14 md:p-8 p-6 flex md:flex-row justify-between flex-col-reverse'>
        <div className='flex flex-col mt-8 md:mt-0 xl:w-2/3 md:w-3/5'>
          <div className='rounded-xl bg-cover bg-center w-full h-[312px]' style={{ backgroundImage: `url(${resolveImageUrl('/uploads/Roaming.png')})` }}>
            <div className='h-full w-full bg-gradient-to-t from-black/80 via-black/60 to-black/80 xl:from-black/60 rounded-xl p-14 flex flex-col justify-end'>
              <div className='xl:w-3/5'>
                <span className='text-textAdditional md:text-4xl text-xl font-extrabold'>{translate('roamingTariff')}</span>
              </div>
            </div>
          </div>
          <div className='w-full flex justify-center items-center'>
            <div className='my-10 w-full md:w-1/2'>
              <Root {...getRootProps()} className={focused ? 'Mui-focused' : ''}>
                <Input className='text-textHigh' placeholder={`${translate('roamingSearch')}`} {...getInputProps()} />
                {theme === 'dark' ? (
                  <Image className='w-6 h-6' src={resolveImageUrl('/uploads/icons/SearchDark.png')} width={15} height={15} alt='' />
                ) : (
                  <Image className='w-6 h-6' src={resolveImageUrl('/uploads/icons/Search.png')} width={15} height={15} alt='' />
                )}
              </Root>
              {groupedOptions.length > 0 && (
                <Listbox {...getListboxProps()}>
                  {groupedOptions.map((option, index) => (
                    <Option {...getOptionProps({ option, index })}>
                      {locale === 'en' ? option?.nameEn : option?.nameMn ?? 'No Name Available'}
                    </Option>
                  ))}
                </Listbox>
              )}
            </div>

          </div>
          <ul className='bg-[#0000001A] border border-[#FFFFFF1A] items-center justify-center p-2 gap-2 rounded-2xl h-fit flex'>
            {dummyData2.map((item, i) => (
              <li
                key={i}
                className={classNames('w-full px-2 lg:px-5 py-2 rounded-xl font-semibold cursor-pointer hover:bg-secondarySoftMain h-10 flex items-center justify-center text-sm text-center', (item.id === selectedService2 ? 'bg-secondary text-textInverse' : 'text-medium text-textHigh'))}
                onClick={() => setSelectedService2(item.id)}
              >{locale === 'mn' ? item.nameMn : item.nameEn}
              </li>
            ))}
          </ul>

          <div className='flex space-x-5 mt-10'>
            <div className='w-full'>
              <div className='xl:border xl:border-secondaryMidStroke flex flex-col rounded-xl h-[400px] overflow-auto no-scrollbar'>
                <div className='text-textHigh'>
                  {selectedService2 === 'price_package' ? <PricePackage data={data} selectedService={selectedService} locale={locale} IMG_URL={IMG_URL} /> : <></>}
                  {selectedService2 === 'data_packages' ? <DataPacakge data={data} selectedService={selectedService} locale={locale} IMG_URL={IMG_URL} /> : <></>}
                  {selectedService2 === 'message_package' ? <MessagePackage data={data} selectedService={selectedService} locale={locale} IMG_URL={IMG_URL} /> : <></>}
                </div>
              </div>
            </div>
          </div>

        </div>
        <div className='hidden md:block md:border-l border-secondaryMidStroke md:pl-12 md:ml-12 xl:w-1/3 md:w-2/5'>
          <div className='sticky top-36'>
            <div className='flex flex-col gap-3'>
              <h1 className='font-bold text-2xl text-textHigh'>{translate('roamingService')}</h1>
              <p className='mt-4 text-textMid text-sm font-medium'>
                {translate('roamingDesc')}
              </p>
              <div className='mt-4 flex justify-start text-start'>
                <a target='_blank' className='text-textMid text-sm font-medium hover:text-blue-500 duration-300' href='https://mfa.gov.mn/en/mongolian-foreign-policy/diplomatic-relations/diplomatic-missions-abroad/' rel='noreferrer'>{translate('roamingEmbassy')}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const blue = {
  100: '#DAECFF',
  200: '#99CCF3',
  400: '#3399FF',
  500: '#007FFF',
  600: '#0072E5',
  700: '#0059B2',
  900: '#003A75'
}

const grey = {
  50: '#F3F6F9',
  100: '#E5EAF2',
  200: '#DAE2ED',
  300: '#C7D0DD',
  400: '#B0B8C4',
  500: '#9DA8B7',
  600: '#6B7A90',
  700: '#434D5B',
  800: '#303740',
  900: '#1C2025'
}

const Root = styled('div')(
  ({ theme }) => `
    font-family: 'IBM Plex Sans', sans-serif;
    font-weight: 400;
    border-radius: 8px;
    color: ${theme.palette.mode === 'dark' ? grey[300] : grey[500]};
    // background: ${theme.palette.mode === 'dark' ? grey[900] : '#fff'};
    border: 1px solid ${theme.palette.mode === 'dark' ? grey[700] : grey[200]};
    box-shadow: 0px 2px 4px ${theme.palette.mode === 'dark' ? 'rgba(0,0,0, 0.5)' : 'rgba(0,0,0, 0.05)'
    };
    display: flex;
    gap: 5px;
    align-items: center;
    padding-right: 5px;
    overflow: hidden;
    width: 100%;

    &.Mui-focused {
      border-color: ${blue[400]};
      box-shadow: 0 0 0 3px ${theme.palette.mode === 'dark' ? blue[600] : blue[200]};
    }

    &:hover {
      border-color: ${blue[400]};
    }

    &:focus-visible {
      outline: 0;
    }
  `
)

const Input = styled('input')(
  ({ theme }) => `
    font-size: 0.875rem;
    font-family: inherit;
    font-weight: 400;
    line-height: 1.5;
    color: ${theme.palette.mode === 'dark' ? grey[300] : grey[900]};
    background: inherit;
    border: none;
    border-radius: inherit;
    padding: 8px 12px;
    outline: 0;
    flex: 1 0 auto;
  `
)

const Listbox = styled('ul')(
  ({ theme }) => `
    font-family: 'IBM Plex Sans', sans-serif;
    font-size: 0.875rem;
    box-sizing: border-box;
    padding: 6px;
    margin: 20px 0;
    width: 34%;
    border-radius: 12px;
    overflow: auto;
    outline: 0;
    max-height: 300px;
    z-index: 1;
    position: absolute;
    background: ${theme.palette.mode === 'dark' ? grey[900] : '#fff'};
    border: 1px solid ${theme.palette.mode === 'dark' ? grey[700] : grey[200]};
    color: ${theme.palette.mode === 'dark' ? grey[300] : grey[900]};
    box-shadow: 0px 2px 3px ${theme.palette.mode === 'dark' ? 'rgba(0,0,0, 0.50)' : 'rgba(0,0,0, 0.05)'
    };
    @media (max-width: 768px) {
      width: 84%;  // Set width to 84% for mobile
    }
    `
)

const Option = styled('li')(
  ({ theme }) => `
    list-style: none;
    padding: 8px;
    border-radius: 8px;
    cursor: default;

    &:last-of-type {
      border-bottom: none;
    }

    &:hover {
      cursor: pointer;
    }

    &[aria-selected=true] {
      background-color: ${theme.palette.mode === 'dark' ? blue[900] : blue[100]};
      color: ${theme.palette.mode === 'dark' ? blue[100] : blue[900]};
    }

    &.Mui-focused,
    &.Mui-focusVisible {
      background-color: ${theme.palette.mode === 'dark' ? grey[800] : grey[100]};
      color: ${theme.palette.mode === 'dark' ? grey[300] : grey[900]};
    }

    &.Mui-focusVisible {
      box-shadow: 0 0 0 3px ${theme.palette.mode === 'dark' ? blue[500] : blue[200]};
    }

    &[aria-selected=true].Mui-focused,
    &[aria-selected=true].Mui-focusVisible {
      background-color: ${theme.palette.mode === 'dark' ? blue[900] : blue[100]};
      color: ${theme.palette.mode === 'dark' ? blue[100] : blue[900]};
    }
    `
)

export default RoamingPage
